const floorToCompactUnit = (number: number): number => {
  const unit = number < 1_000 ? 1 : 1_000 ** Math.floor(Math.log10(number) / 3);
  return Math.floor(number / unit) * unit;
};

export const abbreviateNumber = (number: number, { floor = false }: { floor?: boolean } = {}): string => {
  const value = floor ? floorToCompactUnit(number) : number;
  try {
    return Intl.NumberFormat('en-US', {
      // @ts-ignore -- https://github.com/microsoft/TypeScript/issues/36533
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(value);
  } catch (e) {
    console.error('Failed to abbreviate number. This is likely related to safari 4.2.1', { number, error: e });
    return value.toString();
  }
};
